import React, { type FC } from 'react'
import { SvgIcon, type SvgIconProps } from '@mui/material'

export const DataFilledIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon data-testid="DataFilledIcon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g id="icon/data/filled">
            <path
                id="Vector"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.001 3.45996C14.5185 3.46006 16.9792 4.20834 19.0713 5.6084C21.1635 7.00869 22.7939 8.99862 23.7539 11.3262C23.7573 11.3344 23.7606 11.3432 23.7637 11.3516C23.9189 11.7698 23.9185 12.2298 23.7637 12.6475C23.7606 12.6559 23.7574 12.6645 23.7539 12.6729C22.7939 15.0005 21.1635 16.9903 19.0713 18.3906C16.9791 19.7908 14.5186 20.539 12.001 20.5391C9.48323 20.539 7.02203 19.791 4.92971 18.3906C2.83749 16.9903 1.20707 15.0005 0.247091 12.6729C0.24365 12.6645 0.240463 12.6559 0.237325 12.6475C0.0825504 12.2299 0.0821494 11.7698 0.237325 11.3516L0.247091 11.3262C1.20707 8.9986 2.83752 7.00871 4.92971 5.6084C7.02194 4.2082 9.48335 3.45999 12.001 3.45996ZM12 8.77441C10.2189 8.7745 8.77456 10.2188 8.77444 12C8.77444 13.7813 10.2188 15.2255 12 15.2256C13.7813 15.2255 15.2256 13.7813 15.2256 12C15.2255 10.2188 13.7812 8.77446 12 8.77441Z"
                fill="currentColor"
            ></path>
        </g>
    </SvgIcon>
)
